import { APP_DESKTOP, APP_MOBILE } from "shared/constants/index";

import { isTrue } from "shared/helpers/view";

export const isLatinMelodies =
  import.meta.env.VITE_APP_MULTI_SITE_IDENTITY === "latinmelodies";

export const isCellPhone = import.meta.env.VITE_APP_CELL_PHONE;

export const isMobileLiveChat =
  import.meta.env.VITE_APP_APPLICATION_TYPE === APP_MOBILE;

export const isAmourlee =
  import.meta.env.VITE_APP_MULTI_SITE_IDENTITY === "amourlee";

export const isCupidlee =
  import.meta.env.VITE_APP_MULTI_SITE_IDENTITY === "cupidlee";

export const SITE_IDENTITY = import.meta.env.VITE_APP_MULTI_SITE_IDENTITY;

export const isCupidticket =
  import.meta.env.VITE_APP_MULTI_SITE_IDENTITY === "cupidticket";

export const isQuickmedates =
  import.meta.env.VITE_APP_MULTI_SITE_IDENTITY === "quickmedates";

export const isDesktop =
  import.meta.env.VITE_APP_APPLICATION_TYPE === APP_DESKTOP;

export const isMobile =
  import.meta.env.VITE_APP_APPLICATION_TYPE === APP_MOBILE;

export const MULTI_SITE_IDENTITY = import.meta.env.VITE_APP_MULTI_SITE_IDENTITY;

export const ENABLED_PWA = isTrue(import.meta.env.VITE_APP_PWA_ENABLED);
